module.exports = __webpack_public_path__ + "img/1F1F1-1F1F7.0519b162.svg";